module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/banner/zh-hant-37fe7d7045eef6cd5a93002e7f5d5c7f.jpg";